interface NeedCategory {
  name: string;
  deprecated: boolean;
  shortName: string;
  color: string;
  isFulfilled: boolean;
}

export const needCategories: NeedCategory[] = [
  {
    name: 'Need Identified',
    deprecated: false,
    shortName: 'Identified',
    color: 'pink',
    isFulfilled: false,
  },
  {
    name: 'Resource Connected',
    deprecated: false,
    shortName: 'Connected',
    color: 'blue',
    isFulfilled: false,
  },
  {
    name: 'Need Fulfilled',
    deprecated: true,
    shortName: 'Fulfilled',
    color: 'green',
    isFulfilled: true,
  },
  {
    name: 'Need Fulfilled (Directly)',
    deprecated: false,
    shortName: 'Fulfilled',
    color: 'green',
    isFulfilled: true,
  },
  {
    name: 'Need Fulfilled (Indirectly)',
    deprecated: false,
    shortName: 'Fulfilled',
    color: 'green',
    isFulfilled: true,
  },
];

export const needCategoriesMap = needCategories.reduce(
  (map, category) => {
    map[category.name] = category;
    return map;
  },
  <{ [key: string]: NeedCategory }>{}
);

export interface SelectDto {
  value: any;
  label: string;
  children?: SelectDto[];
}

export const buildNeedCategoryDropdownOptions = (
  optionalAdditionalStatus?: string
): SelectDto[] => {
  const optionStrings = needCategories
    .filter(c => !c.deprecated)
    .map(c => c.name);
  if (
    optionalAdditionalStatus &&
    !optionStrings.find(o => o === optionalAdditionalStatus)
  ) {
    optionStrings.unshift(optionalAdditionalStatus);
  }
  return optionStrings.map(categoryName => ({
    value: categoryName,
    label: categoryName,
  }));
};
